const toSlug = (id: string) => id.trim().toLowerCase().replaceAll(" ", "-");

export const testId = (id: string) => {

    if(!id) {
        return {};
    }

    return process.env.REACT_APP_ENABLE_TESTID === "true"
        ? ({ "data-testid": toSlug(id) } as const)
        : {};
}

